import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { EventTrackerNavigationReasons } from 'src/app/shared/constants';
import { NavItem } from 'src/app/shared/types/NavItem.type';

@Component({
    selector: 'app-nav-item',
    templateUrl: './nav-item.component.html',
    styleUrls: ['./nav-item.component.scss'],
    imports: [CommonModule, MatListModule, MatIconModule, RouterModule, MatTooltipModule, MatBadgeModule],
})
export class NavItemComponent implements OnInit {
    protected EventTrackerNavigationReasons = EventTrackerNavigationReasons;

    @Input() navItem!: NavItem;
    @Input() isExpanded: boolean = false;

    @Output() closeMenu = new EventEmitter<void>();

    constructor() {}

    ngOnInit(): void {}

    executeAction(navItem: NavItem): void {
        if (navItem.type === 'action') {
            navItem.action();
        }
    }
}